
import React from "react";
import WordMockTestGenerator from "@/components/mock-test/WordMockTestGenerator";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";

export default function WordMockTestGeneratorPage() {
  const { isMobile, isSmallMobile, screenSize } = useIsMobile();
  
  return (
    <div className={`container ${isSmallMobile ? 'py-2 px-1' : isMobile ? 'py-3 px-2' : 'py-6 px-4'} mx-auto pb-24 md:pb-6`}>
      <Card className="border-purple-100 shadow-md w-full">
        <CardHeader className={`bg-gradient-to-r from-purple-50 to-blue-50 border-b ${isSmallMobile ? 'p-1.5' : isMobile ? 'p-2 sm:p-3' : 'p-4 sm:p-6'}`}>
          <CardTitle className={`${isSmallMobile ? 'text-sm' : isMobile ? 'text-base' : 'text-xl'} text-secondary`}>
            Word Mock Test Generator
          </CardTitle>
        </CardHeader>
        <CardContent className={`${isSmallMobile ? 'p-1.5' : isMobile ? 'p-2 sm:p-3' : 'p-4 sm:p-6'}`}>
          <WordMockTestGenerator />
        </CardContent>
      </Card>
    </div>
  );
}
